import { render, staticRenderFns } from "./PdfFrame.vue?vue&type=template&id=147c6862&"
import script from "./PdfFrame.vue?vue&type=script&lang=js&"
export * from "./PdfFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports